module.exports = __webpack_public_path__ + "img/blank-comic-book_B098GYT42P.67fdb5c8.jpg";